<template>
<div class="about">
    <v-header />
    <v-sidebar />
    <div class="content-box-entity">
        <div class="content">
            <div>
                <div class="container">
                    <div class="handle-box">

                        <el-select v-model="query.country" allow-create filterable clearable :filter-method="customFilter" style="width: 120px;" placeholder="国家" @clear="handleClear" @change="handleChange">
                            <el-option v-for="item in filteredOptions" :key="item.id" :label="item.title" :value="item.title">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.region" allow-create filterable clearable style="width: 120px;" placeholder="一级地区" @change="handleChange2">
                            <el-option v-for="item in regionlist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.region2" allow-create filterable clearable style="width: 120px;" placeholder="二级地区">
                            <el-option v-for="item in region2list" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-input v-model="query.chinese" style="width: 100px;" placeholder="中文名称" class="handle-input"></el-input>
                        <el-input v-model="query.english" style="width: 120px;" placeholder="其它语言名称" class="handle-input"></el-input>
                        <el-select v-model="query.religion" allow-create filterable clearable style="width: 90px;" placeholder="宗教">
                            <el-option v-for="item in religionlist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.party" style="width: 100px;" allow-create clearable filterable placeholder="派别">
                            <el-option v-for="item in partylist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.type" style="width: 120px;" allow-create clearable filterable placeholder="经营性质">
                            <el-option v-for="item in typelist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-input v-model="query.url" style="width: 120px;" placeholder="网站" class="handle-input "></el-input>
                        <el-input v-model="query.address" style="width: 150px;" placeholder="地址" class="handle-input "></el-input>
                        <el-input v-model="query.email" style="width: 140px;" placeholder="邮箱" class="handle-input "></el-input>
                        <el-input v-model="query.tel" style="width: 140px;" placeholder="电话" class="handle-input "></el-input>
                        <el-input v-model="query.contact" style="width: 150px;" placeholder="其它联系方式" class="handle-input "></el-input>
                        <el-input v-model="query.relation" style="width: 140px;" placeholder="隶属" class="handle-input "></el-input>
                        <el-select v-model="query.language" style="width: 120px;" allow-create clearable filterable placeholder="语言">
                            <el-option v-for="item in languagelist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.status" style="width: 120px;" clearable filterable  placeholder="审核状态">
                            <el-option v-for="item in statuslist" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button type="primary" icon="el-icon-search" style="margin: 5px; width: 120px;" @click="handleSearch">搜索</el-button>
                    </div>
                    <div class="filter-container-right">

                        <el-button v-waves class="filter-item" style="margin-left: 5px; width: 90px;" type="primary" icon="el-icon-plus" :disabled="lander.role=='2'" @click="handleAdd">
                            添加
                        </el-button>

                        <el-button class="filter-item" type="primary" style="margin-left: 10px; width: 90px;" icon="el-icon-upload2" data-step="5" :disabled="lander.role=='2'"  @click="importDetail">
                            导入
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width: 120px;" class="filter-item" type="primary" icon="el-icon-download"  :disabled="lander.role=='2'" @click="handleExportSome">
                            导出选中
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width: 150px;" class="filter-item" type="primary" icon="el-icon-download"  :disabled="lander.role=='2'" @click="handleExportSearch">
                            按查询条件导出
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width: 120px;" class="filter-item" type="primary" icon="el-icon-download" :disabled="lander.role=='2'" @click="handleExport">
                            全部导出
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width:120px" class="filter-item" type="danger" icon="el-icon-delete" :disabled="lander.role=='1'|| lander.role=='2'" @click="handleDeleteSelect">
                            删除选中
                        </el-button>
                        <el-button v-waves style="margin-left: 10px; width:120px" class="filter-item" type="danger" icon="el-icon-delete" :disabled="lander.role=='1'|| lander.role=='2'" @click="handleDeleteAll">
                            全部删除
                        </el-button>

                    </div>
                    <el-table :data="tableData" border fit style="width: 100%;" class="table" ref="table" header-cell-class-name="table-header" size="mini" v-loading="listLoading" row-class-name="success-row" stripe
                    :cell-style="changColor" @selection-change="handleRowSelect" @row-click="handleClick">
                        <el-table-column prop="selects" type="selection" label="选择" width="50" align="center" />
                        <el-table-column type="index" width="50" label="序号" align="center" fixed />
                        <el-table-column prop="country" label="国家" align="center" fixed></el-table-column>
                        <el-table-column prop="region" label="一级地区" align="center" fixed></el-table-column>
                        <el-table-column prop="region2" label="二级地区" align="center" fixed></el-table-column>
                        <el-table-column prop="chinese" label="中文名称" width="120" align="center" fixed></el-table-column>
                        <el-table-column prop="english" label="其它语言名称" width="120" align="center" fixed></el-table-column>
                        <el-table-column prop="language" label="语言" width="100" align="center"></el-table-column>
                        <el-table-column prop="religion" label="宗教" width="100" align="center"></el-table-column>
                        <el-table-column prop="party" label="派别" align="center"></el-table-column>
                        <el-table-column prop="type" label="经营性质" width="100" align="center"></el-table-column>
                        <el-table-column prop="relation" label="隶属于" width="120" align="center"></el-table-column>
                        <el-table-column prop="google" label="Google地图" width="300" show-overflow-tooltip>
                            <template #default="scope">
                                <a :href="scope.row.google" target="_blank" style="text-decoration: none">
                                    {{ scope.row.google }}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="地址" align="center" width="400"></el-table-column>
                        <el-table-column prop="tel" label="电话" width="120" align="center"></el-table-column>
                        <el-table-column prop="email" label="邮箱" align="center" width="400"></el-table-column>
                        <el-table-column prop="url" label="网站" align="center" width="400"></el-table-column>
                        <el-table-column prop="contact" label="其他联系方式" width="150" align="center"></el-table-column>
                        <el-table-column prop="businesshours" label="营业时间" width="150" align="center"></el-table-column>
                        <el-table-column prop="person" label="接洽人" width="150" align="center"></el-table-column>
                        <el-table-column prop="link" label="接洽人联系方式" width="150" align="center"></el-table-column>
                        <el-table-column prop="count" label="拜访次数" width="150" align="center"></el-table-column>
                        <el-table-column prop="remark" label="备注" width="140" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="status" label="审核状态" width="150" align="center"></el-table-column>
                        <!-- <el-table-column label="操作" width="190px" fixed="right" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" icon="el-icon-edit" :disabled="lander.role=='1'" @click="handleEdit(scope.row)">
                                    修改
                                </el-button>
                                <el-button size="mini" class="filter-item" style="margin-left: 5px;" type="danger" icon="el-icon-delete" :disabled="lander.role=='1' " @click="handleDelete(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column> -->
                         <el-table-column label="操作" width="90" align="center" fixed="right">
                                <template #default="scope">
                                    <el-dropdown v-if="lander.role=='100'|| lander.role=='50'">
                                        <el-button type="primary">
                                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <!-- <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-info"
                                                           @click="handleInfo(scope.$index, scope.row)">详情
                                                </el-button>
                                            </el-dropdown-item> -->
                                            
                                            <el-dropdown-item>
                                                <el-button size="mini" type="text" icon="el-icon-edit" :disabled="lander.role=='1'"
                                                           @click="handleEdit(scope.row)">修改
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item >
                                                <el-button size="mini" type="text" icon="el-icon-delete" class="red" :disabled="lander.role=='1'"
                                                           @click="handleDelete(scope.row)">删除
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item >
                                                <el-button size="mini" type="text" icon="el-icon-remove-outline" class="black" v-if="scope.row.mailstatus == 0" :disabled="lander.role=='1' "
                                                           @click="handleBlackMail(scope.row)">拉黑邮箱
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item >
                                                <el-button size="mini" type="text" icon="el-icon-remove-outline" class="black" v-if="scope.row.mailstatus == 1" :disabled="lander.role=='1' "
                                                           @click="handleNotBlackMail(scope.row)">取消拉黑邮箱
                                                </el-button>
                                            </el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>

                                </template>
                            </el-table-column>
                    </el-table>
                    <add-detail ref="addDetail" @addRefresh="addRefresh" /> 
                    <div class="pagination">
                        <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.pageNo" :page-sizes="[10,20,50,100,500,1000,5000]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog class="drawer-title" title="载体清单" :visible.sync="dialogFormVisible" width="450px" center @close="closeImportDialog">
        <div style="text-align: center;">
            <el-tabs class="drawer-item">导入模板请使用主页面导出数据的模板</el-tabs>
            <el-upload drag :before-upload="beforeUploadFile" :show-file-list="false" :action=FILE_ACTION :on-success="handleFileSuccess" accept="Excel/*" :multiple="false">
                <p>点击上传(支持拖拽上传)</p>
            </el-upload>
            <p style="font-size: 15px;color: #888888;">文件大小不超过20MB</p>

        </div>
    </el-dialog>
</div>
</template>

<script>
import vHeader from "./Header.vue";
import vSidebar from "./Sidebar.vue";
import addDetail from './addDetail'
import {
    entity_list_page,
    entity_list_all,
    entity_list_search,
    //importEntity,
    country_list_all,
    entity_del,
    entity_del_all,
    entity_black_mail,
    entity_not_black_mail,
    entity_list_getReligion,
    entity_list_getLanguage,
    entity_list_getParty,
    entity_list_getRegion,
    entity_list_getRegion2,
    entity_list_getType,
    region_list_getRegionByCountry,
    region_list_getRegion2ByRegion,
    admin_forum_move,
    admin_users_type_seeTypes,
    admin_type_getlist
} from '../../api';
import {
    dealResult
} from "../../api/common";
export default {
    name: "EntityList",
    components: {
        vHeader,
        vSidebar,
        addDetail
    },
    data() {
        const confirmEndDate = (rule, str, callback) => {
            if (str === null || typeof str === "undefined" || str === "" || str === "0") {
                callback("请输入结束时间");
            } else if (str < this.topbestData.start) {
                callback('结束时间错误!');
            } else {
                callback();
            }
        };
        return {
            delMsgli: ["广告", "心术不正", "言辞不雅"],
            delVisible: false,
            delData: {},
            files: null,
            decimalPart: '', // 小数点后的字符
            msg: null,
            moveVisible: false,
            listLoading: false,
            FILE_ACTION: '',
            filteredOptions: [], // 用于存储过滤后的选项

            lander: {},
            trashNum: 0,
            typelist: [],
            countrylist: [],
            regionlist: [],
            region2list: [],
            religionlist: [],
            languagelist: [],
            statuslist: [
                {
                    value: '是',
                    label: '是'
                },
                {
                    value: '否',
                    label: '否'
                }
            ],
            partylist: [],
            tableData: [],
            contypelist: [{
                    value: '线上',
                    label: '线上'
                },
                {
                    value: '线下',
                    label: '线下'
                }

            ],
            deleteSeleteData: {},
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            pageTotal: 0,

            topbestVisible: false,
            dialogFormVisible: false,
            topbestData: {
                id: '',
                start: '',
                end: '',
            },
            topbestDataRule: {
                start: [{
                    required: true,
                    message: '不能为空',
                    trigger: 'blur'
                }],
                end: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },
                    {
                        validator: confirmEndDate,
                        trigger: ["change", "blur"]
                    }
                ],
            },
        };
    },
    methods: {

        addRefresh() {
            this.reload()
        },

        // 刷新数据
        reload() {
            this.handleSearch()
        },

        changColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 23 && row.status  === '是') {
        return { color: 'green' }
      }
      if (columnIndex === 23 && row.status === '否') {
        return { color: 'red' }
      }
      
    },

        // 导入记录
        importDetail() {
            this.$confirm('导入前请确保数据格式正确，否则可能导入不成功?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                this.dialogFormVisible = true
            })
        },

        beforeUploadFile(file) {
            const isLt2M = file.size / 1024 / 1024 < 20;
            if (file.name.includes('.')) {
                this.decimalPart = file.name.split('.')[1]; // 分割字符串并获取小数点后的部分
                if (this.decimalPart !== 'xlsx') {
                    return this.$message.error('请上传后缀为xlsx的Excel文件!');
                }
            }
            if (!isLt2M) {
                this.$message.error('上传的Excel文件大小不能超过 20MB!');
                return isLt2M;
            }

            this.loading = this.$loading({
                lock: true,
                text: "上传中，请稍等,,,,",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.5)",
            });
        },

        handleFileSuccess(res) {
            this.loading.close();
            dealResult(res);
            if (res.status == 1) {
                this.$message.success('上传成功');
                this.dialogFormVisible = false
                this.getPage();

            } else {
                this.$message.error(res.msg);
            }

        },

        handleClick(row) {
            this.$refs.table.toggleRowSelection(row)
        },

        // 导出选中
        handleExportSome() {
            if (
                !this.$refs.table.selection || this.$refs.table.selection.length < 1
            ) {
                this.$message({
                    message: '未选中任何记录',
                    type: 'warning'
                })
                return
            }
            this.redirectData = this.deleteSeleteData
            const loading = this.$loading({
                lock: true,
                text: '正在导出...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            // xlsx文件最大1048576行。目前暂定最大导出1万行
            // fetchList({ page: 1, limit: -1 }, {}).then((response) => {
            import('@/utils/Export2Excel').then((excel) => {
                const tHeader = [
                    '国家',
                    '一级地区',
                    '二级地区',
                    '中文名称',
                    '其它语言名称',
                    '语言',
                    '宗教',
                    '派别',
                    '经营性质',
                    '隶属于',
                    'Google地图',
                    '地址',
                    '电话',
                    '邮箱',
                    '网站',
                    '其他联系方式',
                    '营业时间',
                    '接洽人',
                    '接洽人联系方式',
                    '拜访次数',
                    '备注',
                    '审核状态'
                    // '创建人',
                    // '创建时间',
                    // '修改人',
                    // '修改时间'
                ]
                const filterVal = [
                    'country',
                    'region',
                    'region2',
                    'chinese',
                    'english',
                    'language',
                    'religion',
                    'party',
                    'type',
                    'relation',
                    'google',
                    'address',
                    'tel',
                    'email',
                    'url',
                    'contact',
                    'businesshours',
                    'person',
                    'link',
                    'count',
                    'remark',
                    'status'
                    

                    // 'createdBy',
                    // 'creationDate',
                    // 'lastUpdatedBy',
                    // 'lastUpdateDate'
                ]
                const data = this.formatJson(filterVal, this.redirectData)

                loading.close()

                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: this.filename,
                    autoWidth: this.autoWidth,
                    bookType: this.bookType
                })
            })
            // })
        },

         // 按照当前查询条件导出
       handleExportSearch() {

            const loading = this.$loading({
                lock: true,
                text: '正在导出...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            // this.listLoading = true
            // xlsx文件最大1048576行。目前暂定最大导出1万行
            entity_list_search(this.query).then((response) => {

                import('@/utils/Export2Excel').then((excel) => {
                    const tHeader = [
                        '国家',
                        '一级地区',
                        '二级地区',
                        '中文名称',
                        '其它语言名称',
                        '语言',
                        '宗教',
                        '派别',
                        '经营性质',
                        '隶属于',
                        'Google地图',
                        '地址',
                        '电话',
                        '邮箱',
                        '网站',
                        '其他联系方式',
                        '营业时间',
                        '接洽人',
                        '接洽人联系方式',
                        '拜访次数',
                        '备注',
                        '审核状态'
                    ]
                    const filterVal = [
                        'country',
                        'region',
                        'region2',
                        'chinese',
                        'english',
                        'language',
                        'religion',
                        'party',
                        'type',
                        'relation',
                        'google',
                        'address',
                        'tel',
                        'email',
                        'url',
                        'contact',
                        'businesshours',
                        'person',
                        'link',
                        'count',
                        'remark',
                        'status'
                    ]

                    const data = this.formatJson(filterVal, response.data.obj)

                    loading.close()

                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: this.filename,
                        autoWidth: this.autoWidth,
                        bookType: this.bookType
                    })
                })
            })
        },

        // 全部导出
        handleExport() {

            const loading = this.$loading({
                lock: true,
                text: '正在导出...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            // this.listLoading = true
            // xlsx文件最大1048576行。目前暂定最大导出1万行
            entity_list_all(this.query).then((response) => {

                import('@/utils/Export2Excel').then((excel) => {
                    const tHeader = [
                        '国家',
                        '一级地区',
                        '二级地区',
                        '中文名称',
                        '其它语言名称',
                        '语言',
                        '宗教',
                        '派别',
                        '经营性质',
                        '隶属于',
                        'Google地图',
                        '地址',
                        '电话',
                        '邮箱',
                        '网站',
                        '其他联系方式',
                        '营业时间',
                        '接洽人',
                        '接洽人联系方式',
                        '拜访次数',
                        '备注',
                        '审核状态'
                    ]
                    const filterVal = [
                        'country',
                        'region',
                        'region2',
                        'chinese',
                        'english',
                        'language',
                        'religion',
                        'party',
                        'type',
                        'relation',
                        'google',
                        'address',
                        'tel',
                        'email',
                        'url',
                        'contact',
                        'businesshours',
                        'person',
                        'link',
                        'count',
                        'remark',
                        'status'
                    ]

                    const data = this.formatJson(filterVal, response.data.obj)

                    loading.close()

                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: this.filename,
                        autoWidth: this.autoWidth,
                        bookType: this.bookType
                    })
                })
            })
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) =>
                filterVal.map((j) => {
                    if (j === 'timestamp') {
                        return parseTime(v[j])
                    } else {
                        return v[j]
                    }
                }),
            )
        },

        closeImportDialog() {
            // 清空上传excel列表
            document.getElementById('file').value = ''
        },

        handleAdd() {
            this.$refs.addDetail.open().then((that) => {
                that.initData(null, 'add')
            })
        },
        handleEdit(row) {
            this.$refs.addDetail.open().then((that) => {
                that.initData(row, 'edit')
            })
        },

        // 查询操作
        handleSearch() {

            this.query.pageNo = 1;
            this.getPage();
        },

        // 分页导航
        handlePageChange(val) {
            this.query.pageNo = val;
            this.getPage();
        },
        handleSizeChange(val) {
            this.query.pageNo = 1;
            this.query.pageSize = val;
            this.getPage();
        },

        // 删除行
        handleDelete(row) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                }
                entity_del(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
            })
        },

        // 拉黑邮箱处理
        handleBlackMail(row) {
            this.$confirm('此操作将该记录的邮箱拉入黑名单,后续邮件不再发送该邮箱,是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                }
                entity_black_mail(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
            })
        },
        // 取消拉黑邮箱处理
        handleNotBlackMail(row) {
            this.$confirm('此操作将该记录的邮箱取消黑名单,后续邮件将继续发送到该邮箱,是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                }
                entity_not_black_mail(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
            })
        },
        handleRowSelect(selectionChange) {
            this.deleteSeleteData = selectionChange
        },
        handleDeleteAll() {
            this.$confirm('注意！此操作将永久删除全部记录, 请谨慎操作，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                }
                entity_del_all(o).then((res) => {
                    console.log(res);

                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            })
        },

        handleDeleteSelect() {
            this.DeleteData = this.deleteSeleteData
            this.deleteSeleteData
            if (this.deleteSeleteData.length > 0) {
                this.$confirm('此操作将永久删除选中记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((res) => {
                    let o = {
                        uid: this.lander.uid,
                        token: this.lander.token,
                    }
                    this.DeleteData.forEach(element => {
                        o.id = element.id
                        entity_del(o)

                    })
                    this.getPage();
                    this.$message({
                        type: 'info',
                        message: '删除成功'
                    })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请选择要删除的记录'
                })
            }
        },

        suredel() {
            let o = {
                uid: this.lander.uid,
                token: this.lander.token,
                type: this.topbestData.type,
                id: this.delData.id,
                delMsg: this.delData.delMsg,
            }
            admin_forum_del(o).then((res) => {
                dealResult(res.data);
                if (res.data.status == 1) {
                    this.delVisible = false;
                    this.$message.success(res.data.msg);
                    this.getPage();

                } else {
                    this.$message.error(res.data.msg)
                }

            })
        },

        //获取列表数据
        getPage() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.listLoading = true
            entity_list_page(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.tableData = res.data.obj.list
                    this.pageTotal = res.data.obj.total //该页总共多少条记录

                } else {
                    this.$message.error(res.data.msg)
                }
                this.listLoading = false

            })
        },
        //去重获取列表数据
        getItems() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            entity_list_getReligion(this.query).then((res) => {
                this.religionlist = res.data.obj
            })
            entity_list_getLanguage(this.query).then((res) => {
                this.languagelist = res.data.obj
            })
            entity_list_getParty(this.query).then((res) => {
                this.partylist = res.data.obj
            })
            entity_list_getRegion(this.query).then((res) => {
                this.regionlist = res.data.obj
            })
            entity_list_getType(this.query).then((res) => {
                this.typelist = res.data.obj
            })
        },
         handleChange() {
            this.regionlist = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            region_list_getRegionByCountry(this.query).then((response) => {
                this.regionlist = response.data.obj
            })
        },
          handleChange2() {
            this.region2list = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            region_list_getRegion2ByRegion(this.query).then((response) => {
                this.region2list = response.data.obj
            })
        },
        //获取国家清单数据
        getCountry() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;

            country_list_all(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.countrylist = res.data.obj
                    // this.pageTotal = res.data.obj.total //该页总共多少条记录

                } else {
                    this.$message.error(res.data.msg)
                }
                // 初始化时显示所有选项
        this.filteredOptions = this.countrylist;

            })
        },
    customFilter(query) {
      const lowerQuery = query

      // 区分开头匹配和非开头匹配
      const startsWithMatches = this.countrylist.filter(
        item => item.title.startsWith(lowerQuery)
      );
      const containsMatches = this.countrylist.filter(
        item =>
          item.title.includes(lowerQuery) &&
          !item.title.startsWith(lowerQuery)
      );

      // 合并结果，开头匹配在前
      this.filteredOptions = [...startsWithMatches, ...containsMatches];
    },
      handleClear() {
      this.getCountry(); // 确保清空输入框的值
    }

    },
    mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        //去后端查询所有的用户给tableData赋值
        this.getPage();
        this.getCountry();
        this.getItems();
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.faceimg = this.lander.faceimg;
        this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/entity/entitylist/importExcel?uid=' + this.lander.uid + "&token=" + this.lander.token;
        if (this.lander.role == '100') {

        }
        if (this.lander.role == '50') {

        }

    }
}
</script>

<style scoped>
.handle-box {
    margin-bottom: 5px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.black {
    color: #212121;
}

.mr10 {
    margin-right: 10px;
    width: 150px;
}

.content-box-entity {
    position: absolute;
    left: 200px;
    right: 0;
    top: 0px;
    bottom: 0;
    padding-bottom: 30px;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #f0f0f0;
}

.filter-container-right {
    float: right;
}

.pagination {
    display: inline-block;
    padding-left: 200px;
    margin: 20px 0;
    border-radius: 4px;
}

.drawer-item {
    color: rgba(0, 0, 0, .65);
    font-size: 16px;
    padding: 12px 0;
}

.drawer-title {
    margin-bottom: 1px;
    margin-top: 15px;
    color: rgba(0, 0, 0, .85);
    font-size: 22px;
    line-height: 22px;
}

/*滚动条的宽度*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 10px;
}

/*滚动条滑块*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #409eff;
    border-radius: 3px;
}
</style>
